import * as React from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Toolbar,
  Grid2,
  Typography,
} from '@mui/material'
import { confirmable } from 'react-confirm'

import HelpIcon from '@mui/icons-material/Help'

const ConfirmationDialog = ({ show, proceed, confirmation }) => (
  <Dialog
    open={show}
    onClose={() => proceed(false)}
    fullWidth
    maxWidth="sm"
    style={{ zIndex: 4000 }}
  >
    <DialogTitle sx={{ m: 0, p: 0 }}>
      <Toolbar sx={{ color: '#fefefe', backgroundColor: '#75906f', fontWeight: 500 }}>
        <HelpIcon style={{ color: '#fefefe', marginRight: '10px' }} />
        Confirmez votre choix
      </Toolbar>
    </DialogTitle>

    <DialogContent  sx={{ m: 2, pt: 4 }}>
      <Typography variant="body1" mt={2} mb={3}>{confirmation}</Typography>

      <Grid2 container spacing={2} justifyContent="right">
        <Grid2>
          <Button onClick={() => proceed(false)}>
            ANNULER
          </Button>
        </Grid2>

        <Grid2>
          <Button onClick={() => proceed(true)} color="success" variant="contained">
            CONFIRMER MON CHOIX
          </Button>
        </Grid2>
      </Grid2>
    </DialogContent>
  </Dialog>
)

export default confirmable(ConfirmationDialog)